var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F9A01B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.125C10.2071 5.125 10.375 5.29289 10.375 5.5V6.625C10.375 6.83211 10.2071 7 10 7C9.79289 7 9.625 6.83211 9.625 6.625V5.5C9.625 5.29289 9.79289 5.125 10 5.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 10C7.75 8.75736 8.75736 7.75 10 7.75C11.2426 7.75 12.25 8.75736 12.25 10C12.25 11.2426 11.2426 12.25 10 12.25C8.75736 12.25 7.75 11.2426 7.75 10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4472 7.08317C13.5936 6.93672 13.5936 6.69929 13.4472 6.55284C13.3007 6.40639 13.0633 6.40639 12.9168 6.55284L12.1213 7.34833C11.9749 7.49478 11.9749 7.73222 12.1213 7.87866C12.2678 8.02511 12.5052 8.02511 12.6517 7.87866L13.4472 7.08317Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 10C14.875 10.2071 14.7071 10.375 14.5 10.375H13.375C13.1679 10.375 13 10.2071 13 10C13 9.79289 13.1679 9.625 13.375 9.625H14.5C14.7071 9.625 14.875 9.79289 14.875 10Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9168 13.4471C13.0632 13.5936 13.3007 13.5936 13.4471 13.4471C13.5936 13.3007 13.5936 13.0632 13.4471 12.9168L12.6516 12.1213C12.5052 11.9749 12.2677 11.9749 12.1213 12.1213C11.9748 12.2677 11.9748 12.5052 12.1213 12.6516L12.9168 13.4471Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C10.2071 13 10.375 13.1679 10.375 13.375V14.5C10.375 14.7071 10.2071 14.875 10 14.875C9.79289 14.875 9.625 14.7071 9.625 14.5V13.375C9.625 13.1679 9.79289 13 10 13Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87875 12.6516C8.0252 12.5052 8.0252 12.2678 7.87875 12.1213C7.73231 11.9749 7.49487 11.9749 7.34842 12.1213L6.55293 12.9168C6.40648 13.0632 6.40648 13.3007 6.55293 13.4471C6.69937 13.5936 6.93681 13.5936 7.08326 13.4471L7.87875 12.6516Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10C7 10.2071 6.83211 10.375 6.625 10.375H5.5C5.29289 10.375 5.125 10.2071 5.125 10C5.125 9.79289 5.29289 9.625 5.5 9.625H6.625C6.83211 9.625 7 9.79289 7 10Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34836 7.87866C7.49481 8.02511 7.73225 8.02511 7.8787 7.87866C8.02514 7.73221 8.02514 7.49478 7.8787 7.34833L7.0832 6.55283C6.93675 6.40639 6.69932 6.40639 6.55287 6.55283C6.40642 6.69928 6.40642 6.93672 6.55287 7.08316L7.34836 7.87866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switch-icon.0c9f5dcb989ee2e94d29533f1ac257ce.svg";
export { ForwardRef as ReactComponent };